// product card slider and column js

document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll("#columnSelectorMobilemain .columnsMobile");
  const productList = document.querySelector(".product-list .product-list__inner");

  buttons.forEach(btn => {
    btn.addEventListener("click", () => {
      const value = btn.dataset.value;

      productList.style.setProperty("--section-products-per-row", value);

      buttons.forEach(b => b.classList.remove("selected"));
      btn.classList.add("selected");

      setTimeout(() => {
        jQuery('.slick-slider').slick('setPosition');
      }, 50);
    });
  });

  setTimeout(() => {
    jQuery('.product_card_slider').slick({
      infinite: false,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:true
    });
  }, 400);
});


if(document.body.classList.contains('template_product')){
  setTimeout(() => {
    jQuery('.product_card_slider').slick({
      infinite: false,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:true
    });
  }, 800);
}


 

// quick drawer count js

document.addEventListener("DOMContentLoaded", () => {
  const MIN = 1;
  const MAX = 5;
  const EXPIRY_MINUTES = 10;
  const STORAGE_KEY = "inventory_random_value";

  function getRandomInventory() {
    return Math.floor(Math.random() * (MAX - MIN + 1)) + MIN;
  }

  function getSavedValue() {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) return null;

    const data = JSON.parse(saved);
    const now = Date.now();

    if (now - data.timestamp > EXPIRY_MINUTES * 60 * 1000) {
      return null;
    }

    return data.value;
  }

  function saveValue(value) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      value,
      timestamp: Date.now()
    }));
  }

  function applyInventory(el) {
    let value = getSavedValue();

    if (!value) {
      value = getRandomInventory();
      saveValue(value);
    }

    el.textContent = `Only ${value} units left`;
  }

  function updateAllInventories() {
    document.querySelectorAll(".inventory--low.quickaddinventory").forEach(applyInventory);
  }

  updateAllInventories();

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.matches(".inventory--low.quickaddinventory")) {
            applyInventory(node);
          }
          node.querySelectorAll?.(".inventory--low.quickaddinventory").forEach(applyInventory);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});



// announcement slider js

$('.announcement-bar .announcement-bar__list').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay:true,
  arrows:true,
  dots: false,
  autoplaySpeed:2000
});


/* media-and-article page */


document.addEventListener("DOMContentLoaded", function () {

  var cards = document.querySelectorAll(".media-and-article-card");

  cards.forEach(function(card) {
    card.addEventListener("click", function() {
      var imgSrc = this.getAttribute("data-image");
      document.getElementById("modalImage").src = imgSrc;
      document.getElementById("imageModal").style.display = "block";
    });
  });

  document.querySelector(".close-modal").onclick = function () {
    document.getElementById("imageModal").style.display = "none";
  };

  window.onclick = function (e) {
    if (e.target === document.getElementById("imageModal")) {
      document.getElementById("imageModal").style.display = "none";
    }
  };

});



/* media-and-article page end */


// offer js product page
document.addEventListener("DOMContentLoaded", function () {
  const codes = document.querySelectorAll(".copy-offer-code");

  codes.forEach(code => {
    code.addEventListener("click", function () {
      const text = this.getAttribute("data-code");
      const msg = this.parentElement.querySelector(".copied-msg");

      navigator.clipboard.writeText(text).then(() => {
        msg.style.display = "inline";
        setTimeout(() => { msg.style.display = "none"; }, 1500);
      });
    });
  });
});


// document.addEventListener("DOMContentLoaded", function () {
//   const container = document.querySelector(
//     '#facet-filter-filter\\.p\\.product_type .collapsible__content'
//   );
//   if (!container) return;

//   const ORDER = [
//     "DRESS",
//     "TOP SHIRT AND TUNIC",
//     "KURTAS",
//     "3 PCS SET",
//     "CO-ORD SETS",
//     "KURTA DUPATTA SET",
//     "2 PCS SETS",
//     "BOTTOM WEAR",
//     "LEHENGA CHOLI SET",
//     "JUMPSUIT",
//     "DUPATTA",
//     "DRESS DUPATTA SET"
//   ];

//   const MAP = {
//     "DRESS": ["DRESS", "Dress", "SHORT DRESS"],
//     "TOP SHIRT AND TUNIC": ["TOPS", "SHIRTS", "TUNICS"],
//     "KURTAS": ["KURTAS", "Kurta"],
//     "3 PCS SET": ["3 PCS SETS"],
//     "CO-ORD SETS": ["CO-ORD SET", "CO-ORD SETS"],
//     "KURTA DUPATTA SET": ["KURTA DUPATTA SETS", "Salwar Kurta Dupatta"],
//     "2 PCS SETS": ["2 PCS SETS"],
//     "BOTTOM WEAR": ["PANTS", "PALAZZOS"],
//     "LEHENGA CHOLI SET": ["LEHENGA CHOLI SETS"],
//     "JUMPSUIT": ["JUMPSUIT"],
//     "DUPATTA": ["DUPATTA"],
//     "DRESS DUPATTA SET": ["DRESS DUPATTA SETS"]
//   };

//   const allItems = [...container.querySelectorAll(".checkbox-container")];
//   container.innerHTML = "";

//   ORDER.forEach(label => {
//     const matches = allItems.filter(item => {
//       const text = item.querySelector("label")?.textContent.trim().toUpperCase();
//       return MAP[label]?.some(v => text.startsWith(v.toUpperCase()));
//     });

//     if (matches.length) {
//       const first = matches[0];
//       first.querySelector("label").childNodes[0].nodeValue = label + " ";
//       container.appendChild(first);
//     }
//   });
// });

